import softIcon from "images/icons/icon-soft-plus.svg"

export default function PlusIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: softIcon }} />
  )
}
